import React from 'react';
import { useLingui } from '@lingui/react';

import { Box, Flex } from '@rover/kibble/core';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';

import { getBadge, getBannerText, Props } from './BackgroundCheckCallout.common';

function BackgroundCheckCallout({ isInEurope, isInline }: Props): JSX.Element {
  const { i18n } = useLingui();
  const paragraphText = getBannerText(i18n, isInEurope);

  return (
    <Box py="8x" px="4x" data-testid="background-check-callout" backgroundColor="transparent">
      <Flex flexDirection="row" alignItems="center">
        <Box flex="1">
          <TextWithSingleInlineLink
            paragraphText={paragraphText}
            size="200"
            asParagraph
            href={isInEurope ? '/id-verified/' : '/background-checks/'}
            underline
            mb="0x"
            target="_blank"
          />
        </Box>
        <Box flexShrink="0" width="13x" height="10x">
          {getBadge(isInEurope, isInline)}
        </Box>
      </Flex>
    </Box>
  );
}

export default BackgroundCheckCallout;
